module.exports = __webpack_public_path__ + "img/20180815_150609_096.e85ade88.jpg";